import React from 'react'
import { useSelector } from 'react-redux'
import { HashRouter, Switch, Route, Redirect } from 'react-router-dom'

import Header from 'components/Header'
import Auth from 'pages/Login'
import PrivateRoute from 'components/PrivateRoute'
import Users from 'pages/Users'
import Controllers from 'pages/Controllers'
import Events from 'pages/Events'
import ErrorBoundary from 'components/ErrorBoundary'
import Loader from 'react-loader-spinner'

const App = () => {
  const isAuth = useSelector(state => state.isAuth)
  const isLoading = useSelector(state => state.isLoading)

  return (
    <ErrorBoundary>
      <HashRouter>
        {isAuth && <Header />}
        <div className='content'>
          <Switch>
            <Route path='/login'>
              {isAuth ? <Redirect to='/' /> : <Auth />}
            </Route>

            <PrivateRoute path='/users' component={Users} />
            <PrivateRoute path='/controllers' component={Controllers} />
            <PrivateRoute path='/events' component={Events} />

            <Route path='*'>
              {isAuth ? <Redirect to='/users' /> : <Auth />}
            </Route>
          </Switch>
        </div>
      </HashRouter>
      {isLoading && (
        <div className='spinner-overlay'>
          <div className='spinner-content'>
            <Loader type='TailSpin' color='#3B92CF' height={100} width={100} />
          </div>
        </div>
      )}
    </ErrorBoundary>
  )
}

export default App
